<template>
  <div class="_title" :class="{'small': small}">
    <span class="jpn">{{jpn}}</span>
  </div>
</template>

<script>
export default {
  props: {
    eng: {
      type: String,
      default: '',
    },
    jpn: {
      type: String,
      default: '',
    },
    small: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss" scoped>
._title {
  text-align: center;
  color: $white;
  font-size: 24px;
  font-weight: bold;
}
@media screen and  (max-width: $tabletWidth) {
  ._title {
    text-align: center;
    color: $white;
    margin-bottom: 20px;
    .background {
      font-size: 50px;
    }
    .eng {
      margin-top: -60px;
    }
    &.small {
      .background {
        font-size: 50px;
      }
    }
  }
}
</style>
